import React from 'react';

import Divider from 'components/divider/divider';
import NavigationBar from 'components-new/navigation-bar/navigation-bar';

import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';

import { useOrganisationContext } from 'state/context/OrganisationContext';

import getNewNavigationBarLinks, {
  getAccountMenuItems,
  getAccountMenuViews,
} from 'utils/get-new-navigation-bar-links';

import Basis from './components/basis';
import Profile from './components/profile';
import Documents from './components/documents';
import Invoice from './components/invoice';
import Header from './components/header';

const OrganisationJobDetail: React.FC = () => {
  const {
    jobContext: { data: job, isLoading: isJobLoading },
    userContext: { isLoading: isUserLoading },
  } = useOrganisationJobDetail();

  const {
    user: { data: userData },
  } = useOrganisationContext();

  const accountMenuItems = getAccountMenuItems(
    userData?.is_freelancer || false,
  );

  const accountMenuViews = getAccountMenuViews(
    userData?.is_freelancer || false,
    userData?.is_organisation_admin || false,
    userData?.is_staff || false,
    'organisation',
  );

  const links = getNewNavigationBarLinks('assignments');

  return (
    <div className="flex items-center flex-col h-screen w-screen">
      <NavigationBar
        className="col-span-2 w-full"
        user={userData}
        links={links}
        accountMenuItems={accountMenuItems}
        accountMenuViews={accountMenuViews}
      />
      {!isJobLoading && (
        <div className="flex flex-col w-full py-9 px-12  gap-5 md:gap-10 overflow-auto flex-1">
          <Header />
          <Divider orientation="horizontal" className="w-full" />
          <Basis />
          {job.assigned_to && !isUserLoading && (
            <div className="flex flex-col lg:flex-row w-full gap-8">
              <Profile />
              <Documents />
            </div>
          )}
          {!!job.invoice && <Invoice />}
        </div>
      )}
    </div>
  );
};

export default OrganisationJobDetail;
